<template lang="html">
  <article class="product-card-container">
    <router-link class="neutral" :to="{ name: 'publication', params: {id: details.id, title: slugify(details.title)} }">
      <div class="product-card shadow-sm mx-auto">
        <figure class="product-card-image">
          <span class="product-card-image-align-helper"></span>
          <Slideshow
            v-if="images && isRotating"
            :images="images"/>
          <div
            v-else
            class="category-item-image card-img-top my-0"
            :style="`height: 100%; width: 100%; background-image: url(${ imageWithExtensionSmall(image) || noPhoto });`" >
          </div>
          <Band
            class="d-block d-sm-none"
            :active="bandWide && !!bandWide.code"
            :color="bandWide && bandWide.color"
            :text="bandWide && bandWide.text"
            :textColor="'#FFF'" />
          <MarketplaceIcon :active="details.salable"/>
        </figure>
        <div class="product-card-content my-auto">
          <header class="product-card-cat-info d-none d-md-block">
            {{ urlCategory }}
          </header>
          <div class="product-card-title">
            <h4 class="product-card-title">
              <img v-if="icon"
                   alt=""
                   style="height: 1.5rem; margin-bottom: -4px;"
                   :src="iconSrc" >
              {{ details.title | capitalize }}
            </h4>
          </div>
          <div class="product-card-price">
            <div class="republish" v-if="userPublication && isCommerce">
              <font-awesome-icon :class="`republish-icon ${ autoRepublish ? 'green' : 'red' }`"
                                 :icon="[ 'fas', 'history' ]" />
              <span class="republish-tooltip-text d-none d-sm-block">Republicación automática {{ autoRepublish ? 'activa' : 'desactivada' }}</span>
            </div>
            {{ details.price && details.price !== 'Consultar' && details.currency === 'USD' ? 'US' : '' }}{{ details.price | currency }}
          </div>
          <div class="product-card-footer">
            <p>
              <font-awesome-icon
                v-if="city"
                :icon="[ 'fas', 'map-marker-alt' ]"/>
              {{ city }}
            </p>
            <p v-if="user.marketplace && details.salable" class="font-weight-bold text-white px-2" :class="`${  details.stock == 0 ? 'bg-danger' : 'bg-secondary ' }`">
              disponibles: {{ details.stock }} unidades
            </p>
            <p v-else>{{ date | date }}</p>
          </div>
        </div>
      </div>
    </router-link>
    <Band
      class="d-none d-sm-block"
      :active="bandWide && !!bandWide.code"
      :color="bandWide && bandWide.color"
      :text="bandWide && bandWide.text"
      :textColor="'#FFF'" />
  </article>
</template>

<script>
import Slideshow from '@/components/ui/PublicationSlideshow'
import Band from '@/components/ui/PublicationBand'
import MarketplaceIcon from "../ui/MarketplaceIcon";
import CardImpl from './CardImpl'
import { imageWithExtensionSmall } from '@/helpers'
import { slugify } from 'transliteration'

export default (x => x.default || x)({
  ...CardImpl,

  components: {
    Slideshow,
    Band,
    MarketplaceIcon
  },

  methods: {
    imageWithExtensionSmall,

    slugify
  }
})
</script>

<style lang="scss">
@import "../../scss/aspect";
@import "../../scss/colors";
@import "../../scss/breakpoints";
@import "../../scss/fonts";

$card-aspect: 4.42;
$card-max-height: calc((#{$max-width} / 2) / #{$card-aspect});
$card-image-aspect: 1.46;
$card-image-width: calc(#{$card-max-height} * #{$card-image-aspect});

.product-card {
  display: flex;
  font-size: 0.9rem;
  margin-bottom: 10px;
  overflow: hidden;
  width: 98%;
  max-height: $card-max-height;
  min-height: 125px;

  p {
    margin: 0;
    padding: 0;
  }

  &-container {
    position: relative;
    max-height: $card-max-height;
  }

  &-image {
    margin: 0;
    background-color: $gray-300;
    text-align: center;
    width: 100%;
    max-width: $card-image-width;
    position: relative;
  }

  &-image-align-helper {
    display: inline-block;
    height: 100%;
    visibility: hidden;
    position:absolute;
    vertical-align: middle;
  }

  &-content {
    margin: 0.5% 3% 0 2%;
    min-width: 0;
    width:82%;
    height: 110px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &-title {
    font-weight: bold;
    margin-top: auto !important;
    margin-bottom: auto !important;

    & img {
      vertical-align: baseline;
    }

    & h4 {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &-cat-info {
    font-size: 0.8rem;
    width:80%;
    overflow: hidden;
    white-space: nowrap;
    display: block;
    text-overflow:ellipsis;
    direction: rtl;
    margin-top: 0;
    margin-bottom: auto;
  }

  &-price {
    display: flex;
    font-size: 1.25rem;
    color: $primary;
    margin-top: auto;
    margin-bottom: auto;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    margin-top: auto;
    margin-bottom: 0;
  }

  &-container {
    & .carousel.slide {
      height: 100%;

      & .carousel-inner {
        height: 100%;

        & .carousel-item {
          height: 100%;
          background-color: $gray-200;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
}

@media screen and (max-width: map-get($grid-breakpoints, "md")) {
  .product-card {
    width: 100%;

    &-title {
      font-size: 1.125rem !important;
      margin-bottom: auto !important;
      margin-top: 0 !important;

      img {
        height: 1.3rem !important;
      }
    }

    &-price {
      margin-top: auto;
      margin-bottom: auto;
      font-size: 1.25rem;
    }

    &-footer {
      width:90%;
      margin-top: auto;
      margin-bottom: 0;
      display: block;

      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
      }
    }

    &-cat-info {
      width:100%;
      font-size: 0.9rem;
    }

    p {
      font-size: 0.8rem;
      margin: 0;
    }

    &-content {
      margin: 3% 1% 1% 3%;
      background-color: white;
      height: 110px;
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &-image {
      padding: 0;
      max-width: 40%;
    }
  }
}

.category-item-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
}

.republish {
  position: relative;

  &-icon {
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 0.25rem;
    height: 18px !important;
    width: 18px !important;

    &.red {
      color: $red;
    }

    &.green {
      color: $primary;
    }

    & ~ .republish-tooltip-text {
      display: none;
      opacity: 0;
      background-color: $dark;
      color: $white;
      text-align: center;
      font-size: 14px;
      border-radius: 4px;
      max-width: 75vw;
      width: max-content;
      padding: 0.5rem;
      position: absolute;
      bottom: 110%;
      left: -75%;
      z-index: 4;
      transition: ease 0.3s;

      &:before {
        position: absolute;
        left: 10%;
        bottom: -8px;
        content: "";
        border-left: -3px solid transparent;
        border-right: 8px solid transparent;
        border-top: 9px solid $dark;
      }
    }

    &:hover ~ .republish-tooltip-text {
      opacity: 1;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publication/CardWide.vue